import styled from 'shared/utils/styled';

export const Title = styled('h3')(({ theme }) => ({
  margin: 0,
  fontSize: 19,
  fontWeight: 600,
  color: theme.palette.primary.main,
}));

export const Description = styled('p')(() => ({
  margin: 0,
  fontSize: 17,
  fontWeight: 600,
  color: '#454545',
}));
